export enum EventMetricsKeys {
  // Screen Events
  // ...

  // UI Events
  EntityLinkViewedCapabilityTooltip = 'EntityLinkViewedCapabilityTooltip',

  DashboardFilterBarToggledBreach = 'DashboardFilterBarToggledBreach',
  DashboardFilterBarToggledQualityIssue = 'DashboardFilterBarToggledQualityIssue',
  DashboardFilterBarToggledDraft = 'DashboardFilterBarToggledDraft',

  CreateClickedCopyExperienceKeyButton = 'CreateClickedCopyExperienceKeyButton',
  // TODO: refactor all the current UI ones to here

  // Track Events
  PageRedirectedSLOQualityRecommendations = 'PageRedirectedSLOQualityRecommendations',
  PageRedirectedLegacyCatalog = 'PageRedirectedLegacyCatalog',
  PageRedirectedTeam = 'PageRedirectedTeam',
  PageRedirectedProduct = 'PageRedirectedProduct',

  // Operational Events
  // ...
}

export enum EventMetricsTypes {
  Screen = 'screen',
  UI = 'ui',
  Track = 'track',
  Operatinoal = 'operational',
}

export type EventMetricsType = EventMetricType[];
export type EventMetricType = {
  key: EventMetricsKeys;
  data: {};
};
